import styled from 'styled-components'

export const OverlayLoaderContentStyled = styled.div`
  font-weight: bold;
  text-align: center;
`
